import React, { useEffect } from "react";
import styled from "styled-components";

export interface ConfirmBtnProps {
  btnText: string;
  btnSidePadding?: string;
  btnHeight?: number;
  btnColor?: string;
  isDisabled?: boolean;
  btnClickEvent?: () => void;
  btnTextColor?: string;
}

export interface SConfirmBtnContainer {
  btnSidePadding?: string;
  btnHeight?: number;
  btnColor?: string;
}

interface SBtnText {
  btnColor?: string;
  btnTextColor?: string;
}

export default function ConfirmBtn({
  btnText,
  btnSidePadding,
  btnHeight,
  btnColor,
  isDisabled,
  btnClickEvent,
  btnTextColor,
}: ConfirmBtnProps) {
  useEffect(() => {}, [btnColor]);

  return (
    <ConfirmBtnContainer
      btnColor={btnColor}
      btnHeight={btnHeight}
      btnSidePadding={btnSidePadding}
      disabled={isDisabled}
      onClick={() => {
        if (btnClickEvent) {
          btnClickEvent();
        }
      }}
    >
      <BtnText btnColor={btnColor} btnTextColor={btnTextColor}>
        {btnText}
      </BtnText>
    </ConfirmBtnContainer>
  );
}

export const ConfirmBtnContainer = styled.button<SConfirmBtnContainer>`
  height: ${({ btnHeight }) => btnHeight ?? 40}px;
  border-radius: 8px;
  background-color: ${({ btnColor, theme }) =>
    btnColor === "mint"
      ? theme?.buttonColor?.blueNormal
      : btnColor === "red"
      ? theme?.buttonColor?.redNormal
      : theme?.color?.white};
  padding: ${({ btnSidePadding }) => btnSidePadding ?? "0 18px"};
  display: flex;
  align-items: center;

  &:hover {
    background-color: ${({ btnColor, theme }) =>
      btnColor === "mint"
        ? theme?.buttonColor?.blueHover
        : btnColor === "red"
        ? theme?.buttonColor?.redHover
        : theme?.buttonColor?.whiteHover};
  }

  &:active {
    background-color: ${({ btnColor, theme }) =>
      btnColor === "mint"
        ? theme?.buttonColor?.bluePressed
        : btnColor === "red"
        ? theme?.buttonColor?.redPressed
        : theme?.buttonColor?.whitePressed};
  }

  &:disabled {
    background-color: ${({ btnColor, theme }) =>
      btnColor === "mint"
        ? theme?.buttonColor?.blueDisabled
        : btnColor === "red"
        ? theme?.buttonColor?.redDisabled
        : theme?.buttonColor?.whiteDisabled};

    span {
      color: ${({ btnColor, theme }) =>
        btnColor !== "white" ? theme?.color?.white : "#c2cad4"} !important;
    }
  }
`;

export const BtnText = styled.span<SBtnText>`
  font-size: 14px;
  font-weight: bold;
  line-height: 21px;
  text-align: center;
  word-break: keep-all;
  color: ${({ btnColor, theme, btnTextColor }) =>
    btnTextColor ??
    (btnColor !== "white" ? theme?.color?.white : theme?.color?.textColor)};
`;
